import type { SegmentFpsSnapshot, VideoFpsSnapshot } from 'src/utils/perf/types';

import { FpsSampleBuffer } from './fps-sample-buffer';

/**
 * 외부에서 recordFrame()을 호출받아 비디오 프레임 레이트를 계산하는 수집기.
 * FpsCollector(rAF 기반)와 달리 자체 루프 없이 수동 tick 방식으로 동작한다.
 * MediaStreamPipeManager.render()에서 프레임마다 호출된다.
 *
 * 1초 간격으로 프레임 카운트를 합산해 FpsSampleBuffer에 push한다.
 */
export class VideoFpsCollector {
  private frames = 0;

  private windowStart = 0;

  private active = false;

  private buffer = new FpsSampleBuffer();

  public recordFrame(): void {
    const now = performance.now();
    if (!this.active) {
      this.active = true;
      this.windowStart = now;
      this.frames = 0;
    }
    this.frames += 1;
    const elapsed = now - this.windowStart;
    if (elapsed >= 1000) {
      const fps = Math.round(((this.frames * 1000) / elapsed) * 10) / 10;
      this.buffer.push(fps);
      this.frames = 0;
      this.windowStart = now;
    }
  }

  public getSnapshot(withSamples = false): VideoFpsSnapshot | null {
    return this.buffer.getSnapshot(withSamples);
  }

  public getSegmentSnapshot(fromTimestamp: number, toTimestamp: number): SegmentFpsSnapshot | null {
    return this.buffer.getSegmentSnapshot(fromTimestamp, toTimestamp);
  }
}
